export enum BarSizeType {
  BOTTOM,
}
export const BarSizes = {
  [BarSizeType.BOTTOM]: 30,
};
